import { render } from "./HelpModal.vue?vue&type=template&id=27d7d7f7&scoped=true"
import script from "./HelpModal.vue?vue&type=script&lang=js"
export * from "./HelpModal.vue?vue&type=script&lang=js"

import "./HelpModal.vue?vue&type=style&index=0&id=27d7d7f7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27d7d7f7"]])

export default __exports__